// ============================================================================
// APPROVAL ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';

const BASE_PATH = '/lmms/v1/approvals';

export const approvalEndpoints = {
  dashboard: () => buildEndpoint(`${BASE_PATH}/dashboard`),
  detail: (recordType: string, recordId: string) =>
    buildEndpointWithParams(`${BASE_PATH}/detail/:recordType/:recordId`, { recordType, recordId }),
  action: () => buildEndpoint(`${BASE_PATH}/action`),
  history: (recordType: string, recordId: string) =>
    buildEndpointWithParams(`${BASE_PATH}/history/:recordType/:recordId`, { recordType, recordId }),
  auditReport: () => buildEndpoint(`${BASE_PATH}/audit-report`),
} as const;

export default approvalEndpoints;
